import React from "react"
import styles from "./TypeFormCard.module.scss"
import { ClassProps } from "../../utility/common/props"
import cn from "classnames"
import TooltipTrigger from "../TooltipTrigger/TooltipTrigger"

type Tooltip = {
    condition: {
        title: boolean
        description: boolean
    }
    getContent: () => string
}

export interface TypeFormCardProps extends ClassProps {
    icon: JSX.Element
    onSelect: () => void
    title: string
    description?: string
    iconClassName?: string
    mini?: boolean
    testId?: string
}

const TypeFormCard: React.FC<TypeFormCardProps> = props => {
    const { icon, title, description, onSelect, className, iconClassName, mini, testId } = props

    const tooltip: Tooltip = {
        condition: {
            title: title.length > 29,
            description: description ? description.length > 37 : false
        },
        getContent: () => {
            return `${tooltip.condition.title ? title : ""} ${
                tooltip.condition.description && description ? description : ""
            }`.trim()
        }
    }

    return (
        <div
            className={cn(styles.typeFormCard, mini && styles.typeFormCard_mini, className)}
            onClick={onSelect}
            data-testid={testId}
        >
            <div className={cn(styles.typeFormCard__icon, iconClassName)}>{icon}</div>
            <TooltipTrigger
                id={`${testId}-${title}`}
                content={tooltip.getContent()}
                condition={tooltip.condition.title || tooltip.condition.description}
                placement={"auto"}
            >
                <div className={styles.typeFormCard__text}>
                    <span className={styles.typeFormCard__title}>{title}</span>
                    {description && <span className={styles.typeFormCard__desc}>{description}</span>}
                </div>
            </TooltipTrigger>
        </div>
    )
}

export default TypeFormCard
